import { atom } from "recoil";
import { ResultsDTO } from "./../../Models/RaceDetailsDTO";
export const resultsAtom = atom({
  key: "resultsAtom",
  default: {} as ResultsDTO,
});
